import { render, staticRenderFns } from "./QuestionInformation.vue?vue&type=template&id=2019da1b"
import script from "./QuestionInformation.vue?vue&type=script&lang=js"
export * from "./QuestionInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports